<div class="row">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control"
                [(ngModel)]="dtgDriverInfo.searchValue"
                (keyup.enter)="reloadDriverList();">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="reloadDriverList();">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">검색</span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <label class="input-group-text">
                    <i class="mdi mdi-file-tree"></i>
                    <span class="ml-1">
                        그룹
                    </span>
                </label>
            </div>
            <select class="form-control form-control-sm"
                [(ngModel)]="dtgTeamId"
                (ngModelChange)="changeTeamInfo($event)">
                <option [ngValue]="''" *ngIf="limitUserGroupId <= 100">전체그룹</option>
                <option [ngValue]="'undefined'">미설정</option>
                <option *ngFor="let item of listTeam;"
                    [ngValue]="item.dtgTeamId">
                    {{item.dtgTeamNm}}
                </option>
            </select>
        </div>
    </div>
    <div class="col"></div>
    <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-secondary"
            (click)="clickOpenModalFormDriverInfo(DtgActionType.create,null)">
            <i class="mdi mdi-plus"></i>
            <span class="ml-1">
                운전자추가
            </span>
        </button>
    </div>

    <div class="cal-auto">
        <button type="button" class="btn btn-sm btn-outline-success"
            (click)="fileinput.value=null;fileinput.click()">
            <i class="fas fa-file-excel"></i>
            <span class="ml-1">운전자추가</span>
            <input #fileinput type="file" (change)="userRegFromExcel($event)" style="display: none" />
        </button>
    </div>

    <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-success"
            (click)="excelDownload()">
            <i class="fas fa-file-excel"></i>
            <span class="ml-1">엑셀출력</span>
        </button>
    </div>
</div>

<div class="table-responsive mt-3">
    <table class="table table-sm table-hover align-items-center mb-0">
        <thead class="text-nowrap">
            <tr>
                <th>
                    회사이름
                </th>
                <th>
                    그룹이름
                </th>
                <th>
                    ID
                </th>
                <th>
                    운전자이름
                </th>
                <th>
                    화물운송종사자격증
                </th>
                <th>
                    운수종사자ID
                </th>
                <th>
                    생년월일
                </th>
                <th>
                    입사일자
                </th>
                <th [hidden]="listType === DtgListType.modal">
                    편집
                </th>
            </tr>
        </thead>
        <tbody class="text-nowrap">
            <tr *ngFor="let driverInfo of listDriver;let idx = index;">
                <td>
                    <span>{{driverInfo.companyNm}}</span>
                </td>
                <td>
                    <span [hidden]="!driverInfo.dtgTeamNm">{{driverInfo.dtgTeamNm}}</span>
                    <span [hidden]="driverInfo.dtgTeamNm" class="text-warning">
                        미설정
                    </span>
                </td>
                <td>
                    <button type="button" class="btn btn-sm btn-link px-0"
                    [hidden]="listType === DtgListType.list"
                        (click)="clickSelectDriver(driverInfo)">
                        {{driverInfo.userId}}
                    </button>
                    <span
                    [hidden]="listType === DtgListType.modal">
                        {{driverInfo.userId}}
                    </span>
                </td>
                <td>
                    <span [hidden]="!driverInfo.userNm">{{driverInfo.userNm}}</span>
                    <span [hidden]="driverInfo.userNm" class="text-warning">
                        미설정
                    </span>
                </td>
                <td>
                    <span [hidden]="!driverInfo.dtgDriverLcsNo">{{driverInfo.dtgDriverLcsNo}}</span>
                    <span [hidden]="driverInfo.dtgDriverLcsNo" class="text-warning">
                        미설정
                    </span>
                </td>
                <td>
                    <span [hidden]="!driverInfo.drvKotsaDriverId">{{driverInfo.drvKotsaDriverId}}</span>
                    <span [hidden]="driverInfo.drvKotsaDriverId" class="text-warning">
                        미설정
                    </span>
                </td>
                <td>
                    <span [hidden]="!driverInfo.userBirthDt">{{driverInfo.userBirthDt}}</span>
                    <span [hidden]="driverInfo.userBirthDt" class="text-warning">
                        미설정
                    </span>
                </td>
                <td>
                    <span [hidden]="!driverInfo.userHireDt">{{driverInfo.userHireDt}}</span>
                    <span [hidden]="driverInfo.userHireDt" class="text-warning">
                        미설정
                    </span>
                </td>
                <td [hidden]="listType === DtgListType.modal">
                    <button type="button"
                        class="btn btn-sm btn-outline-secondary"
                        (click)="clickOpenModalFormDriverInfo(DtgActionType.update,driverInfo)">
                        <i class="mdi mdi-pen"></i>
                        <span class="ml-1">
                            수정
                        </span>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div class="mt-3">
    <list-paging
        [inputPagingInfo]="pagingInfo"
        (callbackClickPageNumber)="callbackClickPageNumber($event)"
        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
</div>
